import FilterProducts from './FilterProducts';

export default FilterProducts;
